import MainSkills from "../../components/Forms/MainSkills";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";

import ListPip from "./ListPip";

function ListPipTable() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <ListPip/>
            </BasicCard>
        </>
    )
}
export default ListPipTable;